import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [48.867348, 2.314105, 48],
  [48.867463, 2.314155, 48],
];
export default stream;
